[
  {
    "id": 1,
    "type": "degree",
    "degree": "B.Tech in Computer Science",
    "institution": "Anand Engineering College, Agra (AKTU)",
    "location": "Agra, India",
    "startDate": "2023-08",
    "endDate": "2027-05",
    "grade": "Expected",
    "description": "Pursuing B.Tech in Computer Science with focus on Backend Engineering and Machine Learning."
  },
  {
    "id": 2,
    "type": "School",
    "degree": "Intermediate (PCM) & High School (Science)",
    "institution": "Shri Narshingh Bhagwaan Inter College",
    "location": "Agra, India",
    "startDate": "2020-04",
    "endDate": "2022-05",
    "grade": "Completed",
    "description": "Completed high school and intermediate with a focus on science and mathematics."
  }
]